import '../../styles/templates/blog.pcss';

import {Pager} from '../ui/pager';
import '../ui/pager/pager.pcss';

new Pager();
